import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = { class: "block-desc" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "block-body" }
const _hoisted_5 = { class: "block-list" }
const _hoisted_6 = { class: "block-item" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass({ asterisk: _ctx.customAnswerRequired }),
        innerHTML: _ctx.text
      }, null, 10, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customAnswer) = $event)),
            placeholder: "Ваш ответ",
            class: "input",
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.customInp && _ctx.customInp(...args)))
          }, null, 544), [
            [_vModelText, _ctx.customAnswer]
          ])
        ])
      ])
    ]),
    (_ctx.type === 'ONE_PAGE')
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          style: {"margin":"16px 0 8px 0"},
          class: _normalizeClass({ 'is-disabled': _ctx.customAnswer.trim() === '' || _ctx.isDisabled }),
          disabled: _ctx.customAnswer.trim() === '',
          onClick: _ctx.sendAnswer
        }, {
          default: _withCtx(() => [
            (_ctx.currentLang === 'KK')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Жіберу"))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, "Отправить"))
          ]),
          _: 1
        }, 8, ["class", "disabled", "onClick"]))
      : _createCommentVNode("", true)
  ]))
}